import { findImageUrls } from './findImageUrls'
import { Recipe } from '@library/menu-service'

export const getDefaultImage = (crops: ReturnType<typeof findImageUrls>) => {
  if (crops.length === 0) {
    return null
  }

  const sortedSrcs = crops.slice().sort((a, b) => b.width - a.width)
  const midpointInArray = Math.floor(sortedSrcs.length / 2)

  return sortedSrcs[midpointInArray]?.url || ''
}

const getSrcSet = (crops: ReturnType<typeof findImageUrls>) =>
  crops.map((src) => `${src.url} ${src.width}w`).join(', ')

/**
 * Get the recipe image from context
 *
 * This is tested through the component
 *
 * @param {boolean} useHomepageImage - Whether the homepage image should be chosen if possible
 *
 * @example
 *
 *     const [ image, srcSet ] = useRecipeImage(false)
 */
export const getRecipeImage = (recipe: Recipe) => {
  const imageUrls = findImageUrls(recipe.images || [])
  const imageUrl = getDefaultImage(imageUrls)

  if (!imageUrl) {
    return null
  }

  return [imageUrl, getSrcSet(imageUrls)]
}
